// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/copyPaste/copyPaste.css
// module id = 293
// module chunks = 0